import { createAction } from '@reduxjs/toolkit'

export const globalNamespace = 'global'

export const setToken = createAction<string | undefined>(`${globalNamespace}/setToken`)
